import React from 'react';
import { makeStyles, createMuiTheme, MuiThemeProvider, } from '@material-ui/core/styles';
var useStyles = makeStyles({
    '@global': {
        'div, h1, h2, h3, h4, h5, h6, p, a': function (_a) {
            var theme = _a.theme;
            return ({
                margin: 0,
                fontFamily: theme === null || theme === void 0 ? void 0 : theme.typography.fontFamily,
            });
        },
    },
});
var DSThemeProvider = function (_a) {
    var children = _a.children, theme = _a.theme;
    useStyles({ theme: theme });
    return (React.createElement(MuiThemeProvider, { theme: createMuiTheme(theme) }, children));
};
export default DSThemeProvider;
